module.exports = __webpack_public_path__ + "static/logo-black-400-95206a10789fcd1c0be945b59d44e1b3.png";